import { Component , Prop , Mixins, Ref } from 'vue-property-decorator';
import { IRequestSetHomework } from '@/homework/interfaces/request-set-homework.interface';
import { HomeworkMixin } from '@/homework/mixins/homework.mixin';
import { HOMEWORKS_EVENTS, _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import KEYS from '@/values/keys';
import { Section } from '@/courses/models/section.model';
import { WidgetTeacherHomework } from '@/homework/models/widget-teacher-homework.model';
import { SECTION_TYPES } from '@/content/values/sections';
import { PRESENTATION_MODE_EVENTS, CHANGE_PRESENTATION_TASK_USER_EVENT } from '@/content/values/ed-presentation-mode.values';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { WidgetTeacherPerson } from '@/homework/models/widget-teacher-person.model';
import { HomeworksService } from '@/homework/services/homeworks.service';
import EdEdupadEditor from '@/components/common/ed-edupad/ed-edupad-editor/ed-edupad-editor.vue';
import { TextMixin } from '@/components/common/ed-collaborative-text-editor/ed-text.mixin';
import { EDUPAD_COLLECTIONS } from '@/meetings/values/meetings.values';
import { MEETING_EVENTS } from '@/meetings/values/meetings.values';
import {_APP_STORE, SHOW_DISCONNECTED_MODAL_EVENT} from '@/core/values/app.values';
import {OFFLINE_MODE_EVENT} from '@/core/values/core.values';
import { ErrorProvider } from '@/shared/providers/errors.provider';
import { Errors } from '@/shared/values/errors.values';

@Component({
  name: 'ed-response-type-object',
  components: {
    EdEdupadEditor
  }
})
export default class EdResponseTypeObject extends Mixins(HomeworkMixin, TextMixin) {

  /* Props */
  @Prop() readonly section: Section;
  @Prop() readonly responseDraft: WidgetTeacherHomework;
  @Prop() readonly numberResponse: number;
  @Prop() readonly courseId: number;
  @Prop({default: false}) readonly homeworkViewer: boolean;
  @Prop() readonly student: WidgetTeacherPerson; 
  @Ref() readonly loading: any;

  /* Data */  
  public loadEditors: boolean = false;
  public collection : string = '';
  public documents : string[] = [];
  public homeworkId : number = 0;
  public hasToRefreshCourses: boolean = false;
  public isSaving: boolean = false;
  private isEdupadOnline : boolean = false;  //Online flag just for Sharedb server
  private isAppOffline : boolean = false;    //Offline flag for the whole application
  /* Computed */
  get classId(): number {
    return this.section.classId;
  }

  get currentPresentationSection() {
    return this.$store.state.MeetingsStore.currentPresentationSection.current;
  }

  protected getClassId(): number {
    return this.isPresentationMode ? this.currentPresentationSection.classId : this.section.classId;
  }

  protected getSectionId(): number {
    return this.isPresentationMode ? this.currentPresentationSection.sectionId : this.section.sectionId;
  }

  get isSubmitDisabled(): boolean {
    return this.isSaving || this.homeworkViewer || this.isSectionExpired || !this.isEdupadOnline;
  }

  get isSubjectProject() {
    let courseI = SectionsProvider.getCourseIndex({state: this.$store.state.CourseStore, courseId: Number(this.courseId), classId: Number(this.classId)})
    return (this.$store.state.CourseStore.courses.content[courseI]?.viewer?.projectSelected && !this.homeworkViewer) ? true : false;
  }

  get readOnly(){
    return this.isReadOnly();
  }

  get showHistory(){
    if(this.isPresentationMode ){
      if(this.isPresentationModeMainTeacher && this.isCurrentBoardUserTeacher)   // As teacher or Guest teacher 
        return true;
      else if(this.isStudent && this.amICurrentBoardUser)                        // As student on its own homework
        return !this.isSectionExpired;
      else                                                                       // Watching other student homework or teacher document
        return false;
    }
    return true;
  }

  public isReadOnly() : boolean {
    if (this.isPresentationMode) {
      if((this.isPresentationModeMainTeacher || this.isPresentationModeGuestTeacher)){ // Teacher or Guest teacher 
        if(this.isCurrentBoardUserTeacher) {                                                 // -> on teacher document
          return false;
        } else {
          return this.isSectionExpired;                                                      // -> on student document depends of expiration date       
        }                                                                                
      } else if(this.isStudent && this.isCurrentBoardUserTeacher){                     // As student on teacher homework
        return this.isStudentToggle
      } else if(this.isStudent && this.amICurrentBoardUser){                           //  As student on its own homework
        return this.isSectionExpired
      }else if(this.isStudent && !this.amICurrentBoardUser){                          // Watching other student homework
        return true;
      } else {
        return true;
      }
    }
    return this.homeworkViewer || !this.isStudent && this.getResponseDraft();
  }

  get isStudentToggle(){
    return this.$store.state.MeetingsStore.currentMeetingData?.studentToggle || false;
  }

  get isSectionExpired() : any {
    return this.$store.state.HomeworksStore.presentationSectionSelected?.expiration || false;
  }
  
  get hideOverflow(): boolean {
    // TODO: Synchronise scroll for Type Objects
    // return this.isPresentationMode && !this.isPresentationModeMainTeacher && this.isReadOnly();
    return false;
  }   
  
  get showSubmitButton(): boolean {
    return !this.isPresentationMode || (this.isStudent && this.amICurrentBoardUser);
  }

  get responseOwnerId(): number {
    if (this.isPresentationMode) {
      return this.currentBoardUserId ?? this.sessionUserId;
    } else {
      return this.isStudent ? this.sessionUserId : this.responseDraft && this.student?.id ? this.student.id : this.sessionUserId;
    }
  }

  /* Methods */
  private async init() {
    if(this.isPresentationMode && !this.isCurrentBoardUserStudent){
      this.collection = EDUPAD_COLLECTIONS.MEETINGS;
      for (let index = 1; index <= this.numberResponse; index++) {
        this.documents.push(`${this.getClassId()}-${this.getSectionId()}-PM-${index}`)
      } 
    } else if(this.responseDraft){
      this.collection = this.responseDraft.answers?.collection;
      this.documents = this.responseDraft.answers?.documents
      this.homeworkId = this.responseDraft.id;
    } else {
      this.showLoading();
      
      const response: any = await HomeworksService.obtainTypeDraftInfo(this.getClassId(), this.getSectionId(), this.responseOwnerId);
      this.collection = response.answers.collection;
      this.documents = response.answers.documents
      this.homeworkId = response.id;
      let draft = new WidgetTeacherHomework(response);
      this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.UPDATE_STUDENT_HOMEWORK_DRAFT, {
                            courseId: this.courseId, 
                            sectionId:  this.getSectionId(), 
                            draft : draft
                          });
      this.hasToRefreshCourses = true;
      this.hideLoading();
    }
    this.loadEditors = true;
  }

  public saveHomework() {
    let hasPendings = false;
    this.documents.forEach(documentId => {
        const editor = this.$refs[`text-editor-${documentId}`][0]
        if(!editor.hasTextEditorText)
          hasPendings = true;
    });

    if(hasPendings){
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courses.errors.errorTitle'),
        body: this.$i18n.t('homeworks.pendingAnswers'),
        type: KEYS.EVENT_TYPES.WARNING
      });
      return;
    } else {
      let data: IRequestSetHomework = {
        id: this.homeworkId,
        sectionId: this.section.sectionId,
        classId: this.classId,
        name: this.section.name,
        description: this.section.description,
        type: SECTION_TYPES.LESSON_PDF.code,
      }
      this.confirmSaveHomework(data);    
    }    
  }

  private closeTask(){
    this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.CHANGE_CONFIRM_CLOSE_HOMEWORK_VIEWER, false);
    this.$edEventBus.$emit(COURSES_EVENTS.CLOSE_HOMEWORK_VIEWER);
  }

  private confirmSaveHomework(data: IRequestSetHomework) {
    this.$EdModal.createConfirmationModal({
      body: this.$i18n.t('common.confirmSavePdf'),
      action: async () => {
        try {
          this.$EdToast.create({ msg: `${this.$i18n.t('common.sendingResponse')}...` });
          this.isSaving = true;
          await this.createStudentHomework(this.courseId , data);
          if (this.isPresentationMode){
            this.$edEventBus.$emit(CHANGE_PRESENTATION_TASK_USER_EVENT);
            return;
          }
          this.closeTask()
        } catch(err) {
          let message = this.$i18n.t('courses.errors.errorSavingObject');
          let action = undefined;
          if(err.data.errors){
            let errDetail = ErrorProvider.getErrorsOfTheRequest(err.data.errors)[0]
            if( Errors.HW001.code === errDetail.code){
              //Refresh the tasks while showing the error message
              this.$edEventBus.$emit(COURSES_EVENTS.REFRESH_ON_SECTION_UPDATED, { courseId: this.courseId, classId: this.section.classId, sectionId: this.section.sectionId } );
              message = errDetail.message
              action = async () => this.closeTask()
            }
          }
          this.isSaving = false;
          this.$EdToast.hide();
          this.$EdModal.createMessageModal({
            title: this.$i18n.t('courses.errors.errorTitle'),
            body: message,
            type: KEYS.EVENT_TYPES.DANGER,
            action
          });
        }        
      }
    });
  }

  private onViewerClosed() {
    if(this.hasToRefreshCourses && this.homeworkViewer) {
      this.$edEventBus.$emit(COURSES_EVENTS.REFRESH_WIDGET_COURSE, { courseId: this.courseId } );
    }
  }

  /* this is needed because when changing the dom, the editors get deconfigured */
  public reloadEditors(ms : number = 500) { 
    this.loadEditors = false;
    setTimeout(() => { this.loadEditors = true; }, ms);
  }

  protected getResponseDraft(): any {
    return this.responseDraft;
  }

  private showLoading(): void {
    try {
      if (this.loading) this.loading['show']();
    } catch (e) {
        //
    }
  }

  public hideLoading(): void {
    if (this.loading) {
        this.loading['hide']();
    }
  }

  public deleteDocument(){
    if(this.isSaving)                                                 //User is saving, ignore delete event
      return;

    if(this.isPresentationMode && !this.amICurrentBoardUser){         //Not the owner in PM
      this.$edEventBus.$emit(CHANGE_PRESENTATION_TASK_USER_EVENT);
    } else {
      this.$edEventBus.$emit(HOMEWORKS_EVENTS.WHITEBOARD_CLOSED_ON_DELETE, {courseId: this.courseId});
      this.showLoading();
      //The delete event is received before the object is ready (not the PDF), so we need to wait a bit for the updated object
      setTimeout(() => { //First wait for the updated object
        this.$EdModal.createMessageModal({
          title: this.$t('edupad.docDeletedTitle'),
          body: this.$t('edupad.docDeleted'),
          type: KEYS.EVENT_TYPES.WARNING,
          action: () =>  {
            setTimeout(() => {  
              this.$edEventBus.$emit(COURSES_EVENTS.REFRESH_ON_SECTION_UPDATED, { courseId: this.courseId, classId: this.section.classId, sectionId: this.section.sectionId });
              this.closeTask();
              this.hideLoading();
            }, 3000);  //Second wait
          }
        });
      }, 3000);
    } 
  }

  public edupadOnline(){
    this.isEdupadOnline = true;
  }

  public edupadOffline(){
    this.isEdupadOnline = false;
  }

  private setAppOffline(offline: boolean): void {
    this.isAppOffline = offline;
  }

  private setReadonly(){
    if(this.isStudentToggle)
        document.getElementById('pmFocusControl').focus()
    else
      this.reloadEditors(0)
  }

  /* Hooks */
  created() {
    this.$edEventBus.$on(HOMEWORKS_EVENTS.HOMEWORK_VIEWER_IS_CLOSED, this.onViewerClosed);
    this.$edEventBus.$on(COURSES_EVENTS.RElOAD_TYPE_OBJECT_EDITORS, () => { this.homeworkViewer ? this.reloadEditors() : null; });
  }
  
  mounted() {
    const wait = this.isPresentationMode && !this.currentPresentationSection.classId ? 500 : 0;
    setTimeout(() => this.init(), wait)
    setTimeout(() => this.$edEventBus.$emit(PRESENTATION_MODE_EVENTS.LOAD_PRESENTATION_ELEMENTS), 0);
    this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.SET_EDUPAD_ACTIVE, true); //Disable disconected modal
    this.$edEventBus.$on(MEETING_EVENTS.SET_READ_ONLY_STUDENT, this.setReadonly);
    this.$edEventBus.$on(OFFLINE_MODE_EVENT, this.setAppOffline);
  }

  beforeDestroy() {
    this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.CHANGE_CONFIRM_CLOSE_HOMEWORK_VIEWER, false);
    this.$edEventBus.$off(HOMEWORKS_EVENTS.HOMEWORK_VIEWER_IS_CLOSED, this.onViewerClosed);
    this.$edEventBus.$off(COURSES_EVENTS.RElOAD_TYPE_OBJECT_EDITORS);
    this.$edEventBus.$off(MEETING_EVENTS.SET_READ_ONLY_STUDENT);
    this.$edEventBus.$off(OFFLINE_MODE_EVENT, this.setAppOffline);
    this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.SET_EDUPAD_ACTIVE, false); //Enable disconected modal
    if(!this.isPresentationMode && this.isAppOffline){
      this.$edEventBus.$emit(SHOW_DISCONNECTED_MODAL_EVENT, this.isEdupadOnline);
      this.$store.commit(_APP_STORE.MUTATIONS.UPDATE_PREVIOUS_DISCONNECTION_SOCKET, true);
    }
  }
}